import { gql } from '@grandvisionhq/graphql';
import { productPriceItemFragment } from './prices/productPriceItem.js';
import './prices/productPrice.js';
import { mediaFragment, assetFragment } from './small-fragments.js';

const variantFragment = gql`
  fragment variantFragment on Variant {
    assets {
      ...assetFragment
    }
    description
    displayName
    erpId
    header
    isAllowBackOrder
    isAvailableForInStoreSubscription
    isAvailableForSubscription
    isExcludedFromCheckout
    isPublished
    metaTitle
    metaDescription
    promotionIdentifier
    opcoBackendId
    sku
    usps
    media {
      ...mediaFragment
    }
    priceList {
      ...productPriceItemFragment
    }
    bestPrice
    inventory {
      items {
        channel {
          key
          id
        }
        quantity
      }
      totalQuantity
    }
    tags {
      key
      value
    }
  }
  ${mediaFragment}
  ${productPriceItemFragment}
  ${assetFragment}
`;

export { variantFragment };
//# sourceMappingURL=variant.js.map
